var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMfcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.5,
    r: 6,
    fill: "#FFE784"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.5,
    r: 4.5,
    stroke: "#FFEDA2",
    strokeWidth: 3,
    strokeDasharray: "1 5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.06,
    cy: 6.56,
    r: 4.56,
    fill: "#FFD328"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25413 2.95657C4.25413 2.92015 4.28366 2.89062 4.32008 2.89062C4.3565 2.89062 4.38602 2.92015 4.38602 2.95657V3.06595H4.4959C4.53134 3.06595 4.56008 3.09469 4.56008 3.13013C4.56008 3.16558 4.53134 3.19431 4.4959 3.19431H4.38602V3.30468C4.38602 3.3411 4.3565 3.37063 4.32008 3.37063C4.28366 3.37063 4.25413 3.3411 4.25413 3.30468V3.19431H4.14426C4.10881 3.19431 4.08008 3.16558 4.08008 3.13013C4.08008 3.09469 4.10881 3.06595 4.14426 3.06595H4.25413V2.95657ZM3.53441 3.92529C3.53441 3.88887 3.56393 3.85934 3.60035 3.85934C3.63677 3.85934 3.6663 3.88887 3.6663 3.92529V4.03473H3.77568C3.81113 4.03473 3.83986 4.06347 3.83986 4.09891C3.83986 4.13436 3.81113 4.16309 3.77568 4.16309H3.6663V4.2734C3.6663 4.30982 3.63677 4.33934 3.60035 4.33934C3.56393 4.33934 3.53441 4.30982 3.53441 4.2734V4.16309H3.42404C3.3886 4.16309 3.35986 4.13436 3.35986 4.09891C3.35986 4.06347 3.3886 4.03473 3.42404 4.03473H3.53441V3.92529Z",
    fill: "url(#paint0_linear_25945_1116)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05118 6.37013L3.58568 5.04712H2.76318V7.50063H3.25318V5.68412H3.27418L3.81318 7.20663H4.25418L4.80018 5.68412H4.81418V7.50063H5.32518V5.04712H4.52368L4.06518 6.37013H4.05118Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43271 7.50063V6.58013H7.22371V6.13913H6.43271V5.48812H7.35321V5.04712H5.90071V7.50063H6.43271Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6205 6.30013C7.6205 7.03163 7.9145 7.53562 8.667 7.53562C9.0905 7.53562 9.339 7.37462 9.444 7.24863L9.15 6.87063C9.0765 6.95812 8.94 7.07713 8.7125 7.07713C8.345 7.07713 8.17 6.77263 8.17 6.26513C8.17 5.71562 8.338 5.46713 8.667 5.46713C8.926 5.46713 9.0415 5.59313 9.122 5.69113L9.472 5.30263C9.4055 5.22912 9.1885 5.01562 8.7055 5.01562C7.988 5.01562 7.6205 5.52663 7.6205 6.30013Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25945_1116",
    x1: 3.37038,
    y1: 4.33274,
    x2: 3.83802,
    y2: 4.33274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.457414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382428,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.611478
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfcIcon);
export default __webpack_public_path__ + "static/media/mfcIcon.6b7803324cab3574fd23dd56aeec3900.svg";
export { ForwardRef as ReactComponent };